import { render, staticRenderFns } from "./estimate.vue?vue&type=template&id=22324b2a&"
import script from "./estimate.vue?vue&type=script&lang=js&"
export * from "./estimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports